// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Edit: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 10"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M9.679 1.154c.428.428.428 1.12 0 1.549L3.565 8.819a1.908 1.908 0 01-.798.473L.4 9.988A.313.313 0 01.013 9.6l.695-2.366c.089-.3.252-.575.474-.797L7.297.32a1.095 1.095 0 011.549 0l.833.833zm-3.011.68l1.497 1.48 1.072-1.053a.469.469 0 000-.664L8.404.763a.47.47 0 00-.665 0L6.668 1.835zm-.442.443L1.624 6.879a1.24 1.24 0 00-.315.532L.775 9.226l1.814-.534c.201-.059.385-.168.532-.317l4.585-4.6-1.48-1.498z" />
        </svg>
    );
};

export default React.memo(Edit);
